<template>
  <div class="generate" v-loading="loading">
      <img class="canvas-img" :src="canvasSrc" alt="">
      <div class="tips-title">长按图片保存到相册</div>
      <div style="display:none;">
      <!-- <div> -->
      <canvas class="my-canvas" id="canvas" width="750" height="1454" ref="canvas"></canvas>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            loading:false,
            username:window.localStorage.kkusername,
            canvasSrc:''
        }
    },
    created(){
        // console.log(this.$route.query.data)
    },
    mounted(){
        this.canvasGenerate()
    },
    methods:{
        canvasGenerate(){
            this.loading = true
            let canvas = this.$refs.canvas;
            let ctx = canvas.getContext("2d");
            ctx.fillStyle = "#fff";
            ctx.fillRect(0, 0, 750, 1454);
            // 画背景图片
            // let bottom_img = new Image();
            // bottom_img.src = this.canvassbg;
            // bottom_img.onload = () => {
            //   ctx.drawImage(bottom_img, 0, 0, 750, 1454);
            //   // 画头像图片
            //   let avater_img = new Image();
            //   avater_img.src = this.avater;

            //   avater_img.setAttribute("crossOrigin", "Anonymous");
            //   avater_img.onload = () => {
            //       ctx.drawImage(avater_img, 270, 940, 212, 212);

                  ctx.beginPath();
                  ctx.fillStyle = "#000000";
                  ctx.font = "30px normal";
                  ctx.textAlign = "center";
                  ctx.textBaseline = "middle";
                  ctx.fillText(this.username, 375, 180);

                  ctx.fillStyle = "#000000";
                  ctx.font = "30px normal";
                  ctx.textAlign = "center";
                  ctx.textBaseline = "middle";
                  ctx.fillText(this.$route.query.data.title, 375, 400);

                  ctx.fillStyle = "#000000";
                  ctx.font = "30px normal";
                  ctx.textAlign = "center";
                  ctx.textBaseline = "middle";
                  this.drawtext(ctx,this.$route.query.data.content,375,600,600)
                //   ctx.fillText('清华北大', 375, 400);
                  
                    setTimeout(() => {
                        //canvas转换图片
                        let base64_ = canvas.toDataURL("image/png");
                        this.canvasSrc = base64_
                        this.loading = false
                        // console.log(base64_)
                    }, 1000);
            //     };
            // };
        },
        // 文字换行
        drawtext(ctx,t,x,y,w){
            //参数说明
            //ctx：canvas的 2d 对象，t：绘制的文字，x,y:文字坐标，w：文字最大宽度
            let chr = t.split("")
            let temp = ""
            let row = []

            for (let a = 0; a<chr.length;a++){
                if( ctx.measureText(temp).width < w && ctx.measureText(temp+(chr[a])).width <= w){
                    temp += chr[a];
                }else{
                    row.push(temp);
                    temp = chr[a];
                }
            }
            row.push(temp)
            for(let b=0;b<row.length;b++){
                ctx.fillText(row[b],x,y+(b+1)*40);//每行字体y坐标间隔20
            }

        }
    }
}
</script>

<style scoped>
.generate{
    width: 100%;
    height: 100vh;
    position: relative;
    overflow: hidden;
}
.canvas-img{
    width: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
}
.tips-title{
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 1rem;
    font-size: 0.3rem;
}
</style>